import { inject, Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { HnsScreeningService } from '../hns-screening-service';
import { filter, first, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';

@Injectable({ providedIn: 'root' })
export class ScreeningResolver implements Resolve<boolean> {
  private readonly screening$ = toObservable(inject(HnsScreeningService).screening);
  private readonly screeningService = inject(HnsScreeningService);

  resolve(): Observable<boolean> {
    this.screeningService.loadScreening();
    return this.screening$.pipe(
      filter(screening => screening !== null),
      first(),
      map(() => true),
    );
  }
}
